"use client";

import { MobileAppPrompt } from "@/components/MobileAppPrompt/MobileAppPrompt";
import { Container } from "@/src/components/layout/Container";
import Footer from "@/src/components/layout/Footer";
import Navbar from "@/src/components/layout/Navbar";
import { withAuth } from "@/src/hoc/withAuth";

function PrivateLayout({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  return (
    <section>
      <MobileAppPrompt />
      <Navbar />
      <Container>{children}</Container>
      <Footer />
    </section>
  );
}

export default withAuth(PrivateLayout);
